import { Checkbox, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import theme from '../../theme.css';
import { CardFontIcon,DelelteFontIcon } from '../../components/CustomIcons';
import { DataGrid } from '@mui/x-data-grid';
import CustomSection from "../../components/CustomSection";
import CustomTable from "../../components/CustomTable";
import CustomCircularProgress from "../../components/CustomCircularProgress";


const useStyles = makeStyles((theme) => ({
    
}));


export default function CardsView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const { cards, cardsLoading } = props;

    const columns = [
        { field: 'card_number', name: 'Number', width: 150},
        { field: 'expiration', name: 'Expiration Month/Year', width: 200},
        { field: 'is_primary', name: 'Default'}
    ];
   
    console.log("cards:",cards);
    return (
        <CustomSection notMarginTop={true} 
            title={t('cards')} 
            icon={<CardFontIcon style={{
                color: theme.palette.common.white,
            }}/>}
            customClass={classes.customClass}
            actionRight={{
                show: true,
                title:t('btn_add_card'),
                action: props.onAddCard
            }}
        >
            {cardsLoading && <CustomCircularProgress />}
            <CustomTable 
                showHeader={true}
                rows={cards}
                columns={columns}
                textMedium={true}
                columnAction={{
                    title: "Action",
                    icon:<DelelteFontIcon/>,
                    onClick: props.onDeleteCard
                }}
                hiddenFields={['id']}
                customColumns={[
                    {column:'is_primary',type:'checkbox',onClick:props.setPrimaryCard}
                ]}
            />
        </CustomSection>
    );
}